import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition } from "vue"

import {Navbar, Sidebar} from '@/components';
import {useUserStore} from '@/stores/user';
import {computed, onBeforeUnmount, watch} from 'vue';
import {useSettingStore} from '@/stores/setting';
import {useRouter} from 'vue-router';
import {defaultRoles} from '@/utils/defines';
import {transformI18n} from '@/langs/i18n';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import {io} from 'socket.io-client';
import {getToken, removeToken} from '@/utils/auth';
import {ElMessage} from 'element-plus';
import {userLogout} from '@/api/user';
import { getFromLocalStorage } from '@/utils/storage';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let baseUrl = getFromLocalStorage('BaseUrlKey');
baseUrl = baseUrl ? baseUrl.replace('https://', '') : window.location.hostname;

window.socket = io(`wss://${baseUrl}`, {
  query: {},
  transports: ['websocket', 'polling'],
  path: '/ws',
  auth: {
    token: getToken(),
  },
});
window.socket.on('connect', () => {
  console.log('socket.io-connect');
});

window.socket.on('message', (data) => {
  if (data.cmd === 'LOGOUT') {
    const {type} = data.params.payload;
    if (type === 'agencyUpdate') {
      ElMessage.error(transformI18n('home.agencyUpdateMessage'));
    } else if (type === 'infoDEL') {
      ElMessage.error(transformI18n('home.userDeleteMessage'));
    }
    logout();
  }
});

const logout = async () => {
  try {
    await userLogout();
    removeToken();
    window.sessionStorage.clear();
    window.location.reload();
  } catch (e) {
    // do nothing.
  }
};

onBeforeUnmount(() => {
  window.socket.disconnect();
  window.socket.destroy();
});

const router = useRouter();

const userStore = useUserStore();
const settingStore = useSettingStore();

const defaultSideBarList = [{
  navItem: 'home.overview',
  path: '/overview',
  activeIcon: 'icon-overview1',
  icon: 'icon-overview',
  id: 'overview',
}, {
  navItem: 'home.plant',
  path: '/plant',
  activeIcon: 'icon-site1',
  icon: 'icon-site',
  id: 'plant',
}, {
  navItem: 'home.device',
  path: '/device',
  activeIcon: 'icon-device1',
  icon: 'icon-device',
  id: 'device',
}, {
  navItem: 'home.fault',
  path: '/fault-manage',
  activeIcon: 'icon-fault',
  icon: 'icon-guzhang1',
  id: 'fault',
  children: [{
    navItem: 'home.faultConfig',
    path: '/fault-config',
    id: 'fault-config',
  }, {
    navItem: 'home.fault',
    path: '/fault',
    id: 'fault',
  }],
}, {
  navItem: 'home.orgAndUser',
  path: '/user-manage',
  activeIcon: 'icon-user1',
  icon: 'icon-user',
  id: 'orgAndUser',
  children: [{
    navItem: 'home.organization',
    path: '/agency',
    id: 'agency',
  }, {
    navItem: 'home.user',
    path: '/user',
    id: 'user',
  }],
}, {
  navItem: 'home.operation',
  path: '/firmware',
  activeIcon: 'icon-firmware1',
  icon: 'icon-firmware',
  id: 'firmware',
  children: [{
    navItem: 'home.firmware',
    path: '/firmware',
    id: 'firmware',
  }, {
    navItem: 'home.instruction',
    path: '/instruction',
    id: 'instruction',
  },
  ],
}, {
  navItem: 'home.gridProfile',
  path: '/grid',
  activeIcon: 'icon-bingwang',
  icon: 'icon-bingwang1',
  id: 'grid',
}, {
  navItem: 'home.log',
  path: '/log',
  activeIcon: 'icon-log1',
  icon: 'icon-log',
  id: 'log',
}];

const defaultAgencySideBarList = [{
  navItem: 'home.overview',
  path: '/overview',
  activeIcon: 'icon-overview1',
  icon: 'icon-overview',
  id: 'overview',
}, {
  navItem: 'home.plant',
  path: '/plant',
  activeIcon: 'icon-site1',
  icon: 'icon-site',
  id: 'plant',
}, {
  navItem: 'home.device',
  path: '/device',
  activeIcon: 'icon-device1',
  icon: 'icon-device',
  id: 'device',
}, {
  navItem: 'home.fault',
  path: '/fault',
  activeIcon: 'icon-fault',
  icon: 'icon-guzhang1',
  id: 'fault',
}, {
  navItem: 'home.orgAndUser',
  path: '/user-manage',
  activeIcon: 'icon-user1',
  icon: 'icon-user',
  id: 'orgAndUser',
  children: [{
    navItem: 'home.organization',
    path: '/agency',
    id: 'agency',
  }, {
    navItem: 'home.user',
    path: '/user',
    id: 'user',
  }],
}, {
  navItem: 'home.gridProfile',
  path: '/grid',
  activeIcon: 'icon-bingwang',
  icon: 'icon-bingwang1',
  id: 'grid',
}, {
  navItem: 'home.log',
  path: '/log',
  activeIcon: 'icon-log1',
  icon: 'icon-log',
  id: 'log',
}];

const installerSideBarList = [{
  navItem: 'home.overview',
  path: '/overview',
  activeIcon: 'icon-overview1',
  icon: 'icon-overview',
  id: 'overview',
}, {
  navItem: 'home.plant',
  path: '/plant',
  activeIcon: 'icon-site1',
  icon: 'icon-site',
  id: 'plant',
}, {
  navItem: 'home.device',
  path: '/device',
  activeIcon: 'icon-device1',
  icon: 'icon-device',
  id: 'device',
}, {
  navItem: 'home.fault',
  path: '/fault',
  activeIcon: 'icon-fault',
  icon: 'icon-guzhang1',
  id: 'fault',
}, {
  navItem: 'home.user',
  path: '/user',
  activeIcon: 'icon-user1',
  icon: 'icon-user',
  id: 'user',
}, {
  navItem: 'home.gridProfile',
  path: '/grid',
  activeIcon: 'icon-bingwang',
  icon: 'icon-bingwang1',
  id: 'grid',
}, {
  navItem: 'home.log',
  path: '/log',
  activeIcon: 'icon-log1',
  icon: 'icon-log',
  id: 'log',
}];

const endUserSideBarList = [{
  navItem: 'home.overview',
  path: '/overview',
  activeIcon: 'icon-overview1',
  icon: 'icon-overview',
  id: 'overview',
}, {
  navItem: 'home.plant',
  path: '/plant',
  activeIcon: 'icon-site1',
  icon: 'icon-site',
  id: 'plant',
}, {
  navItem: 'home.fault',
  path: '/fault',
  activeIcon: 'icon-fault',
  icon: 'icon-guzhang1',
  id: 'fault',
}, {
  navItem: 'home.gridProfile',
  path: '/grid',
  activeIcon: 'icon-bingwang',
  icon: 'icon-bingwang1',
  id: 'grid',
}];
// , {
//   navItem: 'home.log',
//   path: '/log',
//   activeIcon: 'icon-log1',
//   icon: 'icon-log',
//   id: 'log',
// }];

const include = ['OverView', 'Plant', 'Device', 'Agency', 'User', 'Log', 'Firmware', 'Grid'];

const role = computed(() => userStore.userInfo?.role);
const agencyLevel = computed(() => userStore.userInfo?.level);

const sideBarList = computed(() => {
  if (!role.value) {
    return [];
  }
  if (role.value === defaultRoles.admin.name) {
    return defaultSideBarList;
  }
  if (role.value === defaultRoles.agency.name) {
    if (agencyLevel.value === defaultRoles.agency.installerLevel) {
      return installerSideBarList;
    }
    return defaultAgencySideBarList;
  }
  if (role.value === defaultRoles.user.name) {
    return endUserSideBarList;
  }
  return defaultSideBarList;
});

watch(() => role.value, (newValue) => {
  if (newValue === defaultRoles.user.name && settingStore.isFirstOpen) {
    setTimeout(() => {
      const driverObj = driver({
        allowClose: true,
        steps: [{
          element: '#plant',
          popover: {
            title: transformI18n('home.plant'),
            description: transformI18n('home.addPlant'),
            side: 'right',
            align: 'center',
            nextBtnText: transformI18n('common.nextStep'),
            prevBtnText: transformI18n('common.previousStep'),
            onNextClick: () => {
              router.push('/plant');
              setTimeout(() => {
                driverObj.moveNext();
              }, 1000);
            },
          },
        }, {
          element: '#addPlantButton',
          popover: {
            title: transformI18n('home.plant'),
            description: transformI18n('home.addPlant'),
            side: 'left',
            align: 'start',
            prevBtnText: transformI18n('common.previousStep'),
            doneBtnText: transformI18n('common.add'),
            onNextClick: () => {
              document.querySelector('#addPlantButton').dispatchEvent(new MouseEvent('click'));
              driverObj.moveNext();
            },
          },
        }],
      });
      driverObj.drive();
      settingStore.setIsFirstOpen(false);
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "container" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { height: "100px" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Navbar))
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { class: "innerContainer" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, {
            width: "245px",
            class: "sidebar-container"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Sidebar), { "side-bar-list": _unref(sideBarList) }, null, 8, ["side-bar-list"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component }) => [
                  _createVNode(_Transition, {
                    name: "fade-transform",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_KeepAlive, { include: include }, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                      ], 1024))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})